/** Snackbar/toast variant identifiers (notistack-compatible). */
export const SNACKBAR_VARIANT = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
} as const;
